export const INIT = 'login/INIT';
export const LOAD = 'login/LOAD';

export const AUTO_LOGIN_REQUEST = 'autoLogin/AUTO_LOGIN_REQUEST';
export const AUTO_LOGIN_SUCCESS = 'autoLogin/AUTO_LOGIN_SUCCESS';
export const AUTO_LOGIN_FAILURE = 'autoLogin/AUTO_LOGIN_FAILURE';

export const LOGIN_REQUEST = 'login/LOGIN_REQUEST';
export const SIGNUP_REQUEST = 'signup/SIGNUP_REQUEST';
export const FB_LOGIN_REQUEST = 'login/FB_LOGIN_REQUEST';
export const APPLE_LOGIN_REQUEST = 'login/APPLE_LOGIN_REQUEST';

export const LOGIN_SUCCESS = 'login/LOGIN_SUCCESS';
export const SIGNUP_SUCCESS = 'signup/SIGNUP_SUCCESS';
export const LOGIN_INIT = 'login/LOGIN_INIT';
export const LOGIN_INIT_SUCCESS = 'login/LOGIN_INIT_SUCCESS';
export const LOGIN_INIT_FAILURE = 'login/LOGIN_INIT_FAILURE';
export const LOGIN_FAILURE = 'login/LOGIN_FAILURE';
export const SIGNUP_FAILURE = 'signup/SIGNUP_FAILURE';

export const CHECK_USER = 'login/CHECK_USER';

export const LOAD_SUCCESS = 'login/LOAD_SUCCESS';

export const LOGOUT_REQUEST = 'login/LOGOUT_REQUEST';
export const LOGOUT_FAILURE = 'login/LOGOUT_FAILURE';
export const LOGOUT_SUCCESS = 'login/LOGOUT_SUCCESS';

export const APPLE_CLIENTID =
  process.env.REACT_APP_ENV === 'dev'
    ? 'com.tipsterchat.web.dev'
    : 'com.tipsterchat.web';
export const APPLE_REDIRECT =
  process.env.REACT_APP_ENV === 'dev'
    ? 'https://webappbeta.tipsterchat.com'
    : 'https://webapp.tipsterchat.com';
export const SENTRY_DSN =
  process.env.REACT_APP_ENV === 'dev'
    ? 'https://615239cbab8c4ff480066ddf7e96f733@o277271.ingest.sentry.io/5533537'
    : 'https://43692884609a467ebcac3f0821638a28@o277271.ingest.sentry.io/5533538';
